import React, { useState, useEffect } from "react";
import "./style.css";
import API from "../../utils/API";
import cogoToast from "@successtar/cogo-toast";

function CreateUmbrellaRow({ agents, generateNewRow }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    clientID: "",
    liability: 0,
    premium: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    declaration: "",
    docName: "",
    document: "",
    carrierData: "",
    clients: undefined
  });

  useEffect(() => {
    API.getClients()
      .then((_res) => {
        setFormData((prev) => ({ ...prev, clients: _res.data }));
      })
      .catch((_err) => console.log(_err));

    API.getCarriers()
      .then((_res) => {
        setFormData((prev) => ({ ...prev, carrierData: _res.data }));
      })
      .catch((_err) => console.log(_err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getBase64 = (file, callBack) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      callBack(reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      return error;
    };
  };

  const fileSelectedHandler = (event) => {
    event.preventDefault();

    setFormData((prev) => ({ ...prev, docName: event.target.files[0].name }));

    if (event.target.files[0]) {
      getBase64(event.target.files[0], (res) => {
        setFormData((prev) => ({ ...prev, document: res }));
      });
    }
  };

  const handlePolicyCreate = (event) => {
    event.preventDefault();

    const umbrellaInformation = {
      policyNumber: formData.policyNumber,
      carrier: formData.carrier,
      effectiveDate: formData.effectiveDate,
      clientFirstName: formData.clientFirstName,
      clientLastName: formData.clientLastName,
      clientID: formData.clientID,
      liability: formData.liability,
      premium: formData.premium,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.mainAgentSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.refAgentTwoSplit,
      refAgentThree: formData.refAgentThree,
      refAgentThreeSplit: formData.refAgentThreeSplit,
      refAgentFour: formData.refAgentFour,
      refAgentFourSplit: formData.refAgentFourSplit
    };

    API.saveUmbrellaPolicy(formData.clientID, umbrellaInformation)
      .then((res) => {
        console.log("Saved Umbrella Policy");
        console.log(res.data);
        alert("Saved Umbrella Policy");
        generateNewRow(res.data);

        if (formData.document.length > 0) {
          if (formData.docName.length > 0) {
            API.createDocumentForUmbrella(res.data._id, {
              docName: formData.docName,
              document: formData.document,
              policyid: res.data._id,
              type: "umbrella"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Umbrella Document!");
              })
              .catch((_err) => console.log(_err));
          } else {
            API.createDocumentForUmbrella(res.data._id, {
              docName: "Umbrella Document",
              document: formData.document,
              policyid: res.data._id,
              type: "umbrella"
            })
              .then((_res) => {
                console.log(_res.data);
                cogoToast.success("Uploaded Umbrella Document!");
              })
              .catch((_err) => console.log(_err));
          }
        }
      })
      .catch((_err) => console.log(_err));

    console.log(umbrellaInformation);
  };

  return (
    <tr>
      <td>
        <input
          type="text"
          style={{ width: "50%" }}
          value={formData.clientFirstName}
          onChange={handleInputChange}
          name="clientFirstName"
          placeholder="First"
        />
        <input
          type="text"
          style={{ width: "50%" }}
          value={formData.clientLastName}
          onChange={handleInputChange}
          name="clientLastName"
          placeholder="Last"
        />
      </td>
      <td>
        <input
          type="date"
          style={{ width: "150px" }}
          value={formData.effectiveDate}
          onChange={handleInputChange}
          name="effectiveDate"
          placeholder="Effective Date"
        />
      </td>

      <td>
        <form>
          <input
            list="clients"
            placeholder="Client"
            value={formData.clientID}
            name="clientID"
            onChange={handleInputChange}
          />

          {formData.clients ? (
            <datalist id="clients">
              {formData.clients.map((client) => (
                <option key={client._id} value={client._id}>
                  {client.firstName} {client.lastName}
                </option>
              ))}
            </datalist>
          ) : null}
        </form>
      </td>

      <td>
        <button className="btn-success btn btn" onClick={handlePolicyCreate}>
          Create
        </button>
      </td>

      <td>
        <input
          style={{ width: "250px" }}
          name="fileData"
          type="file"
          onChange={fileSelectedHandler}
        />
      </td>
      <td>
        {formData.carrierData ? (
          <select
            id="carrierDropMenu"
            value={formData.carrier}
            onChange={handleInputChange}
            name="carrier"
          >
            <option value="">--Select a Carrier--</option>
            {formData.carrierData.map((carrier) => (
              <option key={carrier._id} value={carrier.name}>
                {carrier.name}
              </option>
            ))}
          </select>
        ) : (
          <div>No Carriers yet, *Go to Create Carrier option in Admin Tools</div>
        )}
      </td>
      <td>
        <input
          type="text"
          style={{ width: "150px" }}
          value={formData.policyNumber}
          onChange={handleInputChange}
          name="policyNumber"
          placeholder="Policy Number"
        />
      </td>
      <td>
        {agents ? (
          <div>
            <select
              style={{ width: "150px" }}
              id="protegeDropMenu"
              value={formData.mainAgent}
              onChange={handleInputChange}
              name="mainAgent"
            >
              <option value="">--Select an Agent--</option>
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td>
        {agents ? (
          <div>
            <select
              style={{ width: "150px" }}
              id="protegeDropMenu"
              value={formData.refAgentOne}
              onChange={handleInputChange}
              name="refAgentOne"
            >
              <option value="">--Select an Agent--</option>
              {agents.map((agent) => (
                <option key={agent._id} value={agent._id}>
                  {agent.firstName} {agent.lastName}
                </option>
              ))}
            </select>
          </div>
        ) : (
          <div>No agents yet</div>
        )}
      </td>
      <td>
        <input
          style={{ width: "150px" }}
          type="number"
          value={formData.premium}
          onChange={handleInputChange}
          name="premium"
          placeholder="Premium"
        />
      </td>
      <td>Umbrella</td>
      <td>
        <input
          style={{ width: "150px" }}
          type="number"
          value={formData.mainAgentSplit}
          name="mainAgentSplit"
          onChange={handleInputChange}
        />
      </td>
    </tr>
  );
}

export default CreateUmbrellaRow;
